function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import "./template";
import "./style";
/**
 * @typedef DialogOptions
 * @type {object}
 * @property {string} title
 * @property {string} message
 * @property {"error"|"information"|"warning"} type
 * @property {string[]} buttons
 */

var Dialog = /*#__PURE__*/function () {
  /**
   * 
   * @param {DialogOptions} options
   */
  function Dialog(options) {
    _classCallCheck(this, Dialog);

    options = options || {};
    options.buttons = options.buttons || ["ok"];
    options.type = options.type || "information";
    this.options = options;
  }
  /**
   * @param {DialogOptions} options 
   */


  _createClass(Dialog, [{
    key: "show",
    value: function show() {
      this.close();
      /**
       * @type {HTMLTemplateElement} template
       */

      var template = document.querySelector("#dialog-template");
      var messageNode = document.importNode(template.content, true);
      messageNode.querySelector(".dialog-app").setAttribute("data-dialog-app", "true");
      var titleElement = messageNode.querySelector("[data-model='title']");
      titleElement.textContent = this.options.title;
      titleElement.classList.add(this.options.type);
      messageNode.querySelector("[data-model='message']").textContent = this.options.message;
      var buttonsNode = messageNode.querySelector("[data-model='buttons']");

      var _iterator = _createForOfIteratorHelper(this.options.buttons),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var button = _step.value;
          var elem = document.createElement("button");
          elem.classList.add("button");
          elem.classList.add("app_button");
          elem.classList.add("app_inline_button");
          elem.classList.add("dialog-button");
          elem.setAttribute("data-button", button);
          var buttonTitle = document.createElement("div");
          buttonTitle.classList.add("app_button_title");
          buttonTitle.textContent = button;
          elem.appendChild(buttonTitle);
          buttonsNode.appendChild(elem);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      document.body.appendChild(messageNode);
      return new Promise(this.createEvents.bind(this));
    }
    /**
     * 
     * @param {DocumentFragment} messageNode 
     */

  }, {
    key: "createEvents",
    value: function createEvents(resolve) {
      var buttons = document.querySelectorAll("[data-dialog-app] .button");
      var closeAction = this.close;

      for (var x = 0; x < buttons.length; x++) {
        var button = buttons[x];
        var value = button.getAttribute("data-button");
        buttons[x].addEventListener("click", function (value, ev) {
          resolve(value);
          closeAction();
        }.bind(this, value));
      }
    }
  }, {
    key: "close",
    value: function close() {
      var elements = document.querySelectorAll("[data-dialog-app]");

      for (var x = 0; x < elements.length; x++) {
        var item = elements[x];
        item.parentNode.removeChild(item);
      }
    }
  }]);

  return Dialog;
}();

export { Dialog as default };